export interface SubUser {
    id: string,       // Оставляем обязательным для совместимости с существующим кодом
    _id?: string,     // Добавляем поле _id, которое может приходить с сервера
    roles: string[],
    sectors: string[],
    full_name: string,
    email: string,
    sectors_name?: string, // добавил сюда, это нужно только для отображения в селекторе пользователей для формы отчетов
}

export interface LoginSubUser {
    access_token: string,
    token_type: string,
    id: string,      // Оставляем обязательным для совместимости с существующим кодом
    _id?: string,    // Добавляем поле _id, которое может приходить с сервера
    roles: string[],
    sectors: string[],
    full_name: string,
    email: string,
}
export const reportUsersAllowed = [
    'ROIV_KHE@testu.online',
    'ROIV_ZPR@testu.online',
    'ROIV_DNR@testu.online',
    'ROIV_LNR@testu.online',
]


const ROIV_ROLE_ID = "66fbbcb5e33b6b5a875d5fe9"
const MINZDRAV_ROLE_ID = "68e8e3bf45ba501167f42abf"

export const isRoivUser = (user: SubUser) => {
    return user?.roles?.includes(ROIV_ROLE_ID) ?? false
}
export const isMinzdravUser = (user: SubUser) => {
    return user?.roles?.includes(MINZDRAV_ROLE_ID) ?? false
}